import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

export class LicitacaoDetalhePreco extends Component {
  static propTypes = {
    precos: PropTypes.object.isRequired,
    onDownload: PropTypes.func.isRequired
  };

  renderPrecos = data => {
    const { onDownload } = this.props;
    const key = data.get('fornecedor') + '_' + data.get('cnpjCpf');

    return (
      <TableActions
        ref="row"
        key={key}
        data={data.get('idArquivo')}
        onDownload={data.get('idArquivo') && onDownload}
      >
        <td>{data.get('fornecedor')}</td>
        <td>{data.get('cnpjCpf')}</td>
      </TableActions>
    );
  };

  render() {
    const { precos } = this.props;

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader empty={precos.isEmpty()}>
            <tr>
              <th>Fornecedor</th>
              <th>CNPJ/CPF</th>
              <th></th>
            </tr>
          </TableHeader>
          <tbody>{precos.map(this.renderPrecos)}</tbody>
        </table>
      </div>
    );
  }
}

export default LicitacaoDetalhePreco;
